import axios from "./interceptor";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api`;

const getUsers = async (filter) => {
  const response = await axios.post(`${API_URL}/fstools/users`, filter);
  return response;
};

const getUserFromId = async (usersId) => {
  const response = await axios.get(`${API_URL}/users?id=${usersId}`);
  return response;
};

const getAdminUsers = async () => {
  const response = await axios.get(`${API_URL}/users/adminUserList`);
  return response;
};

const searchAdminUsers = async (filters) => {
  const response = await axios.post(
    API_URL + "/users/searchAdminUser",
    filters,
  );
  return response;
};

const deleteAdminUsers = async (actionID) => {
  const response = await axios.post(
    `${API_URL}/users/delete?userId=${actionID}`,
  );
  return response;
};

const getUsersStates = async () => {
  const response = await axios.get(`${API_URL}/users/userStates`);
  return response;
};

const getUserTimeZones = async () => {
  const response = await axios.get(`${API_URL}/users/timeZones`);
  return response;
};

const getUserType = async () => {
  const response = await axios.get(`${API_URL}/users/userTypes`);
  return response;
};

const updateUserTimeZone = async (data) => {
  const response = await axios.put(`${API_URL}/users/updateUserTimeZone`, data);
  return response;
};

// My variable
const getUserRightsIDsfromIconID = async (iconID) => {
  const response = await axios.get(
    `${API_URL}/users/getUserRightsIDsList?IconID=${iconID}`,
  );
  return response;
};

const getAllIcons = async () => {
  const response = await axios.get(`${API_URL}/users/allIcons`);
  return response;
};

const allIcons = async () => {
  const response = await axios.get(`${API_URL}/users/allIcons`);
  return response;
};

const getOneUserRights = async (actionID) => {
  const response = await axios.post(
    `${API_URL}/users/getOneUserRights?userId=${actionID}`,
  );
  return response;
};

const deleteUserRight = async (actionID, rightId) => {
  const response = await axios.post(
    `${API_URL}/users/deleteUserRight?userId=${actionID}&rightId=${rightId}`,
  );
  return response;
};

const toggleActiveUserRight = async (actionID, rightId) => {
  const response = await axios.post(
    `${API_URL}/users/toggleActiveUserRight?userId=${actionID}&rightId=${rightId}`,
  );
  return response;
};

const updateAdminUser = async (data) => {
  const response = await axios.post(API_URL + "/users/updateAdminUser", data);
  return response;
};

const addAdminUser = async (data) => {
  const response = await axios.post(API_URL + "/users/newAdminUser", data);
  return response;
};

const getUserId = async () => {
  const response = await axios.get(`${API_URL}/users/getUserId`);
  return response;
};

const getAllRights = async () => {
  const response = await axios.get(`${API_URL}/users/allRights`);
  return response;
};

const getAllStatuses = async () => {
  const response = await axios.get(`${API_URL}/users/userStatuses`);
  return response;
};

const getIconIdFromName = async (iconName) => {
  const response = await axios.get(
    `${API_URL}/users/getIconIdFromName?iconName=${iconName}`,
  );
  return response;
};

const searchRights = async (data) => {
  const response = await axios.post(API_URL + "/users/searchRights", data);
  return response;
};

const updateRight = async (data) => {
  const response = await axios.post(API_URL + "/users/updateRight", data);
  return response;
};

const addRight = async (data) => {
  const response = await axios.post(API_URL + "/users/newRight", data);
  return response;
};

const addIconObject = async (data) => {
  const response = await axios.post(API_URL + "/users/newIconObject", data);
  return response;
};

const addIconRight = async (data) => {
  const response = await axios.post(API_URL + "/users/newIconRight", data);
  return response;
};

const deleteRight = async (rightId) => {
  const response = await axios.delete(
    `${API_URL}/users/deleteRight?rightId=${rightId}`,
  );
  return response;
};

const deleteIcon = async (iconId) => {
  const response = await axios.delete(
    `${API_URL}/users/deleteIcon?IconID=${iconId}`,
  );
  return response;
};

const deleteAllIconRights = async (iconId) => {
  const response = await axios.delete(
    `${API_URL}/users/deleteAllIconRights?IconID=${iconId}`,
  );
  return response;
};

const toggleActiveIcon = async (iconId) => {
  const response = await axios.post(
    `${API_URL}/users/toggleActiveIcon?IconID=${iconId}`,
  );
  return response;
};

const toggleActiveRight = async (rightId) => {
  const response = await axios.post(
    `${API_URL}/users/toggleActiveRight?rightId=${rightId}`,
  );
  return response;
};

const getRoles = async () => {
  const response = await axios.get(`${API_URL}/users/roles`);
  return response;
};

const updateRole = async (data) => {
  const response = await axios.post(API_URL + "/users/updateRole", data);
  return response;
};

const addRole = async (data) => {
  const response = await axios.post(API_URL + "/users/newRole", data);
  return response;
};

const deleteRole = async (roleId) => {
  const response = await axios.post(
    `${API_URL}/users/deleteRole?roleId=${roleId}`,
  );
  return response;
};

const toggleActiveRole = async (roleId) => {
  const response = await axios.post(
    `${API_URL}/users/toggleActiveRole?roleId=${roleId}`,
  );
  return response;
};

const getAllRoles = async () => {
    const response = await axios
        .get(`${API_URL}/users/getAllRoles`);
    return response;
}

const getAllLanguages = async () => {
    const response = await axios
        .get(`${API_URL}/users/allLanguages`);
    return response;
}

const addLanguage = async (data) => {
    const response = await axios
        .post(API_URL + "/users/addLanguage", data);
    return response;
}

const updateLanguage = async (data) => {
    const response = await axios
        .post(API_URL + "/users/updateLanguage", data);
    return response;
}

const deleteLanguage = async (languageId) => {
        const response = await axios.post(API_URL + "/users/deleteFullLanguage", languageId);
        return response.data;
}

const getRSCallBehavior = async () => {
    const response = await axios.get(`${API_URL}/users/getRSLanguageCallBehavior`);
    return response.data;
}

const setRSCallBehavior = async () => {
    const response = await axios.post(`${API_URL}/users/setRSLanguageCallBehavior`);
    return response.data;
}

const getAllLanguagesForUser = async (userId) => {
    const response = await axios
        .get(`${API_URL}/users/allLanguagesForUser?userId=${userId}`);
    return response;
}

const submitLanguagesForUser = async (data) => {
    const response = await axios
        .post(API_URL + "/users/submitUserLanguage", data);;
    return response;
}

const deleteUserLanguage = async (language) => {
    const response = await axios
        .post(`${API_URL}/users/deleteLanguage?id=${language}`);
    return response;
}

const addUserRights = async (data) => {
  const response = await axios.post(API_URL + "/users/newUserRights", data);
  return response;
};

const updateChecklist = async (data) => {
  const response = await axios.post(API_URL + "/users/updateChecklist", data);
  return response;
};

const addChecklist = async (data) => {
  const response = await axios.post(API_URL + "/users/newChecklist", data);
  return response;
};

const deleteChecklist = async (checklistId) => {
  const response = await axios.post(
    `${API_URL}/users/deleteChecklist?checklistId=${checklistId}`,
  );
  return response;
};

const toggleActiveChecklist = async (checklistId) => {
  const response = await axios.post(
    `${API_URL}/users/toggleActiveChecklist?checklistId=${checklistId}`,
  );
  return response;
};

const getAllChecklist = async () => {
  const response = await axios.get(`${API_URL}/users/getAllChecklist`);
  return response;
};

const getAllISPEvents = async () => {
  const response = await axios.get(`${API_URL}/users/getAllEvents`);
  return response;
};

const searchChecklist = async (name) => {
  const response = await axios.post(
    `${API_URL}/users/searchChecklistItems?name=${name}`,
  );
  return response;
};

const updateObjective = async (data) => {
  const response = await axios.post(API_URL + "/users/updateObjective", data);
  return response;
};

const addObjective = async (data) => {
  const response = await axios.post(API_URL + "/users/newObjective", data);
  return response;
};

const deleteObjective = async (objectiveId) => {
  const response = await axios.post(
    `${API_URL}/users/deleteObjective?objectiveId=${objectiveId}`,
  );
  return response;
};

const toggleActiveObjective = async (objectiveId) => {
  const response = await axios.post(
    `${API_URL}/users/toggleActiveObjective?objectiveId=${objectiveId}`,
  );
  return response;
};

const getAllObjective = async () => {
  const response = await axios.get(`${API_URL}/users/getAllObjectives`);
  return response;
};

const getAllChecklistNames = async () => {
  const response = await axios.get(`${API_URL}/users/getAllChecklistNames`);
  return response;
};

const getObjectivesForOneUser = async (userId) => {
  const response = await axios.get(
    `${API_URL}/users/getObjectivesForOneUser?userId=${userId}`,
  );
  return response;
};

const getAllObjectivesforUser = async () => {
  const response = await axios.get(`${API_URL}/users/getObjectivesForUser`);
  return response;
};

const assignObjective = async (data) => {
  const response = await axios.post(
    API_URL + "/users/assignObjectiveToUser",
    data,
  );
  return response;
};

const deleteUserObjective = async (userObjectiveId, clientId) => {
  const response = await axios.post(
    `${API_URL}/users/deleteUserObjective?usersObjectiveId=${userObjectiveId}&clientId=${clientId}`,
  );
  return response;
};

const getAllSSOAssociations = async () => {
  const response = await axios.get(`${API_URL}/users/ssoEmailAssociations`);
  return response;
};

const createSSOAssociation = async (email, usersId) => {
  let data = {
    usersId: usersId,
    email: email,
  };
  const response = await axios.post(
    `${API_URL}/users/createSSOEmailAssociation`,
    data,
  );
  return response;
};

const updateSSOAssociation = async (email, usersId) => {
  let data = {
    usersId: usersId,
    email: email,
  };
  const response = await axios.put(
    `${API_URL}/users/updateSSOEmailAssociation`,
    data,
  );
  return response;
};

const deleteSSOAssociation = async (usersId) => {
  const response = await axios.delete(
    `${API_URL}/users/removeSSOEmailAssociation?usersId=${usersId}`,
  );
  return response;
};

const fetchUserFromEmail = async (email) => {
  const response = await axios.get(
    `${API_URL}/users/UserInfoFromEmail?email=${email}&fromSPA=true`,
  );
  return response;
};

const updateUsesMultipleLocations = async (data) => {
  const response = await axios.post(
    API_URL +
      `/users/updateUsesMultipleLocations?usersId=${data.usersId}&updateValue=${data.updateValue}`,
  );
  return response;
};
const getSentimentOptions = () => {
  return axios.get(`${API_URL}/users/getSentimentOptions`);
};

const setSentimentOptions = (payload) => {
  return axios.post(`${API_URL}/users/setSentimentOptions`, payload);
};

const getUserDob = async (userId) => {
  const response = await axios.get(
    API_URL + `/users/get-userdob?userId=${userId}`,
  );
  return response;
};

const getUserNotes = async (userId) => {
  const response = await axios.get(`${API_URL}/users/notes?userId=${userId}`);
  return response;
};

const postUserNote = async (notePayload) => {
  const response = await axios.post(`${API_URL}/users/notes`, notePayload);
  return response;
};

export {
    getUsers,
    getUserFromId,
    getAdminUsers,
    searchAdminUsers,
    deleteAdminUsers,
    getUsersStates,
    getUserTimeZones,
    getUserType,
    getOneUserRights,
    deleteUserRight,
    toggleActiveUserRight,
    updateAdminUser,
    addAdminUser,
    getUserId,
    getAllRights,
    searchRights,
    updateRight,
    addRight,
    deleteRight,
    toggleActiveRight,
    getRoles,
    updateRole,
    addRole,
    deleteRole,
    toggleActiveRole,
    getAllRoles,
    addUserRights,
    getUserRightsIDsfromIconID,
    getAllIcons,
    allIcons,
    addIconObject,
    getIconIdFromName,
    addIconRight,
    deleteIcon,
    deleteAllIconRights,
    toggleActiveIcon,
    updateChecklist,
    addChecklist,
    deleteChecklist,
    toggleActiveChecklist,
    getAllChecklist,
    getAllISPEvents,
    searchChecklist,
    updateObjective,
    addObjective,
    deleteObjective,
    toggleActiveObjective,
    getAllObjective,
    getAllChecklistNames,
    getAllObjectivesforUser,
    getObjectivesForOneUser,
    assignObjective,
    deleteUserObjective,
    getAllStatuses,
    getAllSSOAssociations,
    createSSOAssociation,
    fetchUserFromEmail,
    updateUserTimeZone,
    updateUsesMultipleLocations,
    getSentimentOptions,
    setSentimentOptions,
    updateSSOAssociation,
    deleteSSOAssociation,
    getUserDob,
    getAllLanguages,
    getAllLanguagesForUser,
    submitLanguagesForUser,
    deleteUserLanguage,
    addLanguage,
    updateLanguage,
    deleteLanguage,
    getRSCallBehavior,
    setRSCallBehavior,
    getUserNotes,
    postUserNote
}